import { CommuneDTO } from "@utils/appUtils.ts";

export interface PlainteData {}

export interface DropDownList {
  name: string;
  code: string;
}

export interface StepCallBack {
  isResolvedComplaint?: boolean;
  onNext: () => void;
  onPrevious?: () => void;
  onResolve?: (e: boolean) => void;
}

export interface NatureComplaintDTO {
  id: number;
  idLabel: string;
  name: string;
  type: string;
  subNatures: SubNatureComplaint[];
}

export interface SubNatureComplaint {
  id: number;
  description: string;
  natureId: number;
  isCustom: boolean;
  isNonReceipt?: boolean
}

export interface ComplaintDTO {
  id: number;
  date: string;
  category: string;
  type: string;
  priority: string;
  description: string;
  status: string;
  resolutionDate: string;
  comments: string;
}

export interface CompaintRegionReportDTO {
  regionName: string;
  complaintReceived: string;
  complaintResolved: string;
  complaintINProgress: string;
  complaintFrequencyCategory: string;
  satisfactionPercentage: string;
}

export interface EntityComplaintDTO {
  entity: string;
  complaintReceived: string;
}

export interface TableNatureOfComplaintDTO {
  natureOfComplaint: string;
  complaintNumber: string;
}

export interface ComplaintCategoryDTO {
  reference: number;
  age: string;
  sex: string;
  complaintnumber: string;
  region: string;
}

// Download PDF
export interface ComplaintReceivedPdf {
  id?: number;
  receivedDate: string;
  agent: string;
  complainant: string;
  fokontany: string;
  ref: string;
  phoneNumber: string;
}

export interface ComplaintPostDTO {
  description: string;
  incidentLocation: string;
  careInstructions: any[];
  rsuRelated: boolean;
  incidentDate: Date;
  receivedDate: Date;
  sensivity: string;
  resolutionLevel: string;
  status: string;
  priority: string;
  actionTaken: string;
  userUuid: string;
  reportId: string | null;
  fokontanyId: number;
  complaintUserProfilId: string;
  natures: number[];
  subNatures: number[];
  aggressors: ComplaintAgressorDTO[];
  complaintDetails: ComplaintDetailsDTO[];
  complaintInfo: ComplaintInfosDTO;
  supportTypes: any[];
  object: ObjectInternalAgent | null;
  complaintSubNatures: ComplaintSubNatures[]
}
export interface ComplaintSubNatures{
  subnatureId: number,
  natureId: number | string,
  additionalInfo: string | null
}

export interface ComplaintListDTO {
  data: DataComplaint[];
}
export interface DataComplaint {
  complaintId: string;
  complainant: string;
  aggressors: string;
  complaintRef: string;
  receivedDate: string;
  complaintStatus: string;
  complaintType: string;
  complaintPriority: string;
}
export interface ComplaintDetailsDTO {
  id?: number;
  complaintId?: number;
  lastName: string;
  firstName?: string;
  gender: string | null;
  ageGroup: string | null;
  disability: boolean;
  cin: string;
  householdId: string;
  individualId: string;
  parentCohabitation: boolean;
  disabilityInfo?: any | null;
  contactNumber: string;
  contactAddress: string;
  fatherName: string;
  motherName: string;
  personType?: ComplaintPersonType | null;
  // martialStatus: ComplaintMatrimonialSituation | null;
  martialStatus: any;
  student?: string | null;
  employee?: string | null;
}

export interface ComplaintAgressorDTO {
  id?: number;
  firstName: string;
  lastName: string;
  gender: string;
  address: string;
  ageGroup: number | string;
  victimRelationShip: string;
  nationality: string;
  complaintId?: number;
}

export interface ComplaintAssessmentsDTO {
  id: number;
  complaintId: number;
  rsuRelated: boolean;
  sensivity: string;
  resolutionLevel: string;
}

export interface ComplaintInfosDTO {
  id?: number;
  complaintId?: number;
  fullName: string;
  cinNumber: string;
  phoneNumber: string;
  householdId: string;
  individualId: string;
  address: string;
  relationshipWithVictim?: string | null;
  disabled: boolean;
  anonym?: boolean;
  isVictim?: boolean;
  firstName?: string;
  lastName?: string;
}

export enum ComplaintStatus {
  ESCALATED = "ESCALATED",
  PENDING = "PENDING",
  ARCHIVED = "ARCHIVED",
  RESOLVED_POSITIVE = "RESOLVED_POSITIVE",
  RESOLVED_NEGATIVE = "RESOLVED_NEGATIVE",
  IN_PROGRESS = "IN_PROGRESS",
  SAVED = "SAVED",
  IN_PROGRESS_VALIDATION = "IN_PROGRESS_VALIDATION",
  CURRENTLY_PROCESSED = "CURRENTLY_PROCESSED",
  AWAITING_RESPONSE = "AWAITING_RESPONSE",
  RESOLVED = "RESOLVED",
}

export interface ComplaintGetDTO {
  id: number;
  ref: string;
  natures: NatureComplaintDTO[];
  aggressors: ComplaintAgressorDTO[];
  complaintDetails: ComplaintDetailsDTO[];
  status: string;
  receivedDate: Date;
}

export interface ComplaintPostResponseDTO {
  id: number;
  description: string;
  incidentLocation: string;
  careInstruction: string;
  incidentDate: Date;
  receivedDate: Date;
  status: string;
  priority: string;
  user: UserDTO;
  report: ReportDTO;
  fokontany: FokontanyDTO;
  natures: NatureComplaintDTO[];
  subNatures: SubNatureComplaint[];
  aggressors: ComplaintAgressorDTO[];
  complaintDetails: ComplaintDetailsDTO[];
  complaintAssessments: ComplaintAssessmentsDTO[];
  complaintInfos: ComplaintInfosDTO[];
}

interface ReportDTO {
  id: number;
  partnerId: number;
  periode: Date;
  importDate: Date;
  type: string;
  status: string;
}
interface FokontanyDTO {
  id: number;
  name: string;
  code: string;
  municipality?: MunicipalityDTO;
}

interface MunicipalityDTO {
  id: number;
  name: string;
  code: string;
  district: {
    id: number;
    name: string;
    code: string;
    region: {
      id: number;
      name: string;
      code: string;
      districts: string[];
    };
    municipalities: string[];
  };
  fokontanies: string[];
}

interface UserDTO {
  id: string;
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  address: string;
  createdAt: string;
  profil: ProfilDTO;
  fokontany: FokontanyDTO;
}

export interface ComplaintByIdDTO {
  id: number;
  description: string;
  ref: string;
  incidentLocation: string;
  careInstruction: string;
  incidentDate: string;
  receivedDate: string;
  status: string;
  priority: string;
  user: UserComplaintDTO;
  report: ReportDTO;
  fokontany: FokontanyDTO;
  natures: NatureComplaintDTO[];
  subNatures: SubNatureComplaint[];
  aggressors: AggressorDTO[];
  complaintDetails: ComplaintDetailsDTO[];
  complaintAssessments: ComplaintAssessmentDTO[];
  complaintInfos: ComplaintInfosDTO[];
}

export interface GuichetUniqueDto {
  complainant: ComplaintInfosDTO;
  victim: ComplaintDetailsDTO
}
export interface MembersGuichetUniqueDto {
  individualId: string;
  fullName: string;
}


export interface UserComplaintDTO {
  userId: { value: string };
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  telephone: string;
  address: string;
  password: string;
  status: string;
  profil: ProfilDTO;
  fokontany: FokontanyDTO;
}

export interface ProfilDTO {
  profilId: { value: string };
  name: string;
  description: string;
  permissions: PermissionDTO[];
}

export interface PermissionDTO {
  id?: string;
  permissionId?: string;
  name: string;
  description: string;
  profiles?: string[];
}

export interface DistrictDTO {
  id: number;
  name: string;
  code: string;
  region: RegionDTO;
  municipalities: string[];
}

export interface RegionDTO {
  id: number;
  name: string;
  code: string;
  districts: string[];
}

export interface AggressorDTO {
  id: number;
  firstName: string;
  lastName: string;
  gender: string;
  address: string;
  age: number;
  victimRelationShip: string;
  nationality: string;
  complaintId: number;
}

export interface ComplaintAssessmentDTO {
  id: number;
  complaintId: number;
  rsuRelated: boolean;
  sensivity: string;
  resolutionLevel: string;
}

export interface complaintPutDTO {
  complaintId: number;
  status: string;
  supportTypes: number[];
  actionTaken: string;
  userId: number;
  profilUuid: string;
}

export enum ComplaintDisabledInfo {
  PHYSICAL = "PHYSICAL",
  INTELLECTUAL = "INTELLECTUAL",
  HEARING = "HEARING",
  VISUAL = "VISUAL",
}

export enum ComplaintIncidentLocation {
  HOME = "HOME",
  SCHOOL = "SCHOOL",
  STREET = "STREET",
  PUBLIC_TRANSPORT = "PUBLIC_TRANSPORT",
  HEALTH_CENTER = "HEALTH_CENTER",
  WORKPLACE = "WORKPLACE",
  PUBLIC_INSTITUTION = "PUBLIC_INSTITUTION",
  INTERNET_SOCIAL_MEDIA = "INTERNET_SOCIAL_MEDIA",
  OTHER = "OTHER",
}

export enum ComplaintCareInstruction {
  MEDICAL_ASSISTANCE = "MEDICAL_ASSISTANCE",
  PSYCHOLOGICAL_ASSISTANCE = "PSYCHOLOGICAL_ASSISTANCE",
  POLICE_SUPPORT = "POLICE_SUPPORT",
  TEMPORARY_HOUSING = "TEMPORARY_HOUSING",
  LEGAL_FOLLOW_UP = "LEGAL_FOLLOW_UP",
  NGO_REFERRAL = "NGO_REFERRAL",
  SOCIAL_REINTEGRATION = "SOCIAL_REINTEGRATION",
}

export enum ComplaintRelationshipWithVictim {
  FATHER = "FATHER",
  MOTHER = "MOTHER",
  STEPFATHER = "STEPFATHER",
  STEPMOTHER = "STEPMOTHER",
  WIFE_OR_HUSBAND = "WIFE_OR_HUSBAND",
  BIOLOGICAL_SIBLING = "BIOLOGICAL_SIBLING",
  NEIGHBOR = "NEIGHBOR",
  FAMILY = "FAMILY",
  FRIEND = "FRIEND",
  CLOSE_FRIEND = "CLOSE_FRIEND",
  TEACHER = "TEACHER",
  EMPLOYER = "EMPLOYER",
  OTHER = "OTHER",
  NONE = "NONE",
}

export enum ComplaintAgeGroup {
  FROM_0_TO_5 = "FROM_0_TO_5",
  FROM_6_TO_10 = "FROM_6_TO_10",
  FROM_11_TO_17 = "FROM_11_TO_17",
  FROM_18_TO_20 = "FROM_18_TO_20",
  FROM_21_TO_25 = "FROM_21_TO_25",
  FROM_26_TO_30 = "FROM_26_TO_30",
  FROM_30_TO_35 = "FROM_30_TO_35",
  FROM_36_TO_40 = "FROM_36_TO_40",
  FROM_41_TO_45 = "FROM_41_TO_45",
  FROM_46_TO_50 = "FROM_46_TO_50",
  FROM_51_TO_55 = "FROM_51_TO_55",
  FROM_56_TO_60 = "FROM_56_TO_60",
  FROM_61_TO_65 = "FROM_61_TO_65",
  FROM_66_TO_70 = "FROM_66_TO_70",
  FROM_71_TO_PLUS = "FROM_71_TO_PLUS",
}

export enum ComplaintMatrimonialSituation {
  MARIED = "MARIED",
  SINGLE = "SINGLE",
  DIVORCED = "DIVORCED",
  WIDOWED = "WIDOWED",
}

export enum complaintPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum ComplaintPersonType {
  STUDENT = "STUDENT",
  SENSITIVE = "SENSITIVE",
}

export enum ComplaintResolutionLevel {
  LOCAL = "LOCAL",
  REGIONAL = "REGIONAL",
  CENTRAL = "CENTRAL",
}

export enum ComplaintSensitivity {
  NON_SENSITIVE = "NON_SENSITIVE",
  EMPLOYEE = "EMPLOYEE",
  OTHER = "OTHER",
}

export enum ComplaintReportType {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY",
  SPECIFIC = "SPECIFIC",
}

export enum ComplaintReportStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum ComplaintGender {
  MALE = "MALE",
  FEMALE = "FEMALE",
}

export enum ComplaintJob {
  YES = "YES",
  NO = "NO",
  UNKNOWN = "UNKNOWN",
}

export enum TypeProfil {
  ADMIN = "ADMIN",
  INTERNAL = "INTERNAL",
  EXTERNAL = "EXTERNAL",
  COMPETENT_ENTITY = "COMPETENT_ENTITY",
  RGS = "RGS",
  CGP = "CGP",
  PFM = "PFM",
  ADMIN_DRPS = "ADMIN_DRPS",
  ADMIN_PSRC = "ADMIN_PSRC",
  COMMUNICATION = "COMMUNICATION",
  DGRSU = "DGRSU",
}

export enum ObjectInternalAgent {
  REGISTRATION = "REGISTRATION",
  TARGETING = "TARGETING",
  DELIVERY_SERVICE = "DELIVERY_SERVICE",
  SUPPORT_SERVICE = "SUPPORT_SERVICE",
  COMPLAINT_HANDLING_MECHANISM = "COMPLAINT_HANDLING_MECHANISM",
}

export interface StepThreeReason {
  description: string;
  location: any;
  incidentDate: Date;
  incidentHour: any;
  receivedDate: string;
  status: string;
  priority: string;
  userUuid: string;
  reportId: string;
  fokontanyId: number;
  region?: RegionDTO;
  district?: DistrictDTO;
  commune?: CommuneDTO;
  fokotany?: FokontanyDTO;
  otherLocation?: string;
  object?: {
    code: ObjectInternalAgent,
    name: string
  };
}

export interface StepsReason {
  stepOne: {
    date: Date;
    region: RegionDTO;
    district: DistrictDTO;
    commune: CommuneDTO;
    fokotany: FokontanyDTO;
  } | null;
  stepTwo: ComplaintInfosDTO | null;
  stepThree: StepThreeReason | null;
  stepFour: {
    natureComplaintSelectedList: NatureComplaintDTO[];
    subNatureComplaintSelectedList: SubNatureComplaint[];
    complaintSubNatures: ComplaintSubNatures[]
  };
  stepFive: ComplaintAssessmentsDTO | null;
  victimStep: ComplaintDetailsDTO | null;
  agressorStep: ComplaintAgressorDTO | null;
}

export const objectLists = [
  { name: "Enregistrement", code: ObjectInternalAgent.REGISTRATION },
  { name: "Ciblage", code: ObjectInternalAgent.TARGETING },
  {
    name: "Service de délivrance (cash ou en nature)",
    code: ObjectInternalAgent.DELIVERY_SERVICE,
  },
  {
    name: "Service d'accompagnement",
    code: ObjectInternalAgent.SUPPORT_SERVICE,
  },
  {
    name: "Mécanisme de gestion des plaintes",
    code: ObjectInternalAgent.COMPLAINT_HANDLING_MECHANISM,
  },
];

export const ageGroup = [
  { name: "0-5 ans", code: ComplaintAgeGroup.FROM_0_TO_5 },
  { name: "6-10 ans", code: ComplaintAgeGroup.FROM_6_TO_10 },
  { name: "11-17 ans", code: ComplaintAgeGroup.FROM_11_TO_17 },
  { name: "18-20 ans", code: ComplaintAgeGroup.FROM_18_TO_20 },
  { name: "21-25 ans", code: ComplaintAgeGroup.FROM_21_TO_25 },
  { name: "26-30 ans", code: ComplaintAgeGroup.FROM_26_TO_30 },
  { name: "30-35 ans", code: ComplaintAgeGroup.FROM_30_TO_35 },
  { name: "36-40 ans", code: ComplaintAgeGroup.FROM_36_TO_40 },
  { name: "41-45 ans", code: ComplaintAgeGroup.FROM_41_TO_45 },
  { name: "46-50 ans", code: ComplaintAgeGroup.FROM_46_TO_50 },
  { name: "51-55 ans", code: ComplaintAgeGroup.FROM_51_TO_55 },
  { name: "56-60 ans", code: ComplaintAgeGroup.FROM_56_TO_60 },
  { name: "61-65 ans", code: ComplaintAgeGroup.FROM_61_TO_65 },
  { name: "66-70 ans", code: ComplaintAgeGroup.FROM_66_TO_70 },
  { name: "71 ans et plus", code: ComplaintAgeGroup.FROM_71_TO_PLUS },
];

export interface AgressorsInfos {
  id: number;
  lastName: string;
  firstName: string;
  sex: string;
  age?: number | string;
  nationality?: string;
  relation?: DropDownList;
  adresse: string;
}

export const relationShip = [
  { name: "Père", code: ComplaintRelationshipWithVictim.FATHER },
  { name: "Mère", code: ComplaintRelationshipWithVictim.MOTHER },
  { name: "Beau-père", code: ComplaintRelationshipWithVictim.STEPFATHER },
  { name: "Belle-mère", code: ComplaintRelationshipWithVictim.STEPMOTHER },
  {
    name: "Époux(se)",
    code: ComplaintRelationshipWithVictim.WIFE_OR_HUSBAND,
  },
  {
    name: "Frère ou sœur biologique",
    code: ComplaintRelationshipWithVictim.BIOLOGICAL_SIBLING,
  },
  { name: "Voisin", code: ComplaintRelationshipWithVictim.NEIGHBOR },
  { name: "Famille", code: ComplaintRelationshipWithVictim.FAMILY },
  { name: "Ami", code: ComplaintRelationshipWithVictim.FRIEND },
  { name: "Ami proche", code: ComplaintRelationshipWithVictim.CLOSE_FRIEND },
  { name: "Enseignant", code: ComplaintRelationshipWithVictim.TEACHER },
  { name: "Employeur", code: ComplaintRelationshipWithVictim.EMPLOYER },
  { name: "Autre", code: ComplaintRelationshipWithVictim.OTHER },
  { name: "Aucune relation", code: ComplaintRelationshipWithVictim.NONE },
];

export const disabledInfoList = [
  { name: "Physique", code: ComplaintDisabledInfo.PHYSICAL },
  { name: "Intellectuel", code: ComplaintDisabledInfo.INTELLECTUAL },
  { name: "Auditif", code: ComplaintDisabledInfo.HEARING },
  { name: "Visuel", code: ComplaintDisabledInfo.VISUAL },
];

export const instructions = [
  {
    name: "Assistance médicale",
    code: ComplaintCareInstruction.MEDICAL_ASSISTANCE,
  },
  {
    name: "Assistance psychologique",
    code: ComplaintCareInstruction.PSYCHOLOGICAL_ASSISTANCE,
  },
  {
    name: "Prise en charge par la police",
    code: ComplaintCareInstruction.POLICE_SUPPORT,
  },
  {
    name: "Hébergement temporaire",
    code: ComplaintCareInstruction.TEMPORARY_HOUSING,
  },
  { name: "Suivi juridique", code: ComplaintCareInstruction.LEGAL_FOLLOW_UP },
  {
    name: "Orientation vers une ONG",
    code: ComplaintCareInstruction.NGO_REFERRAL,
  },
  {
    name: "Réintégration sociale",
    code: ComplaintCareInstruction.SOCIAL_REINTEGRATION,
  },
];

export const statusList = [
  { name: "En cours", code: ComplaintStatus.IN_PROGRESS },
  { name: "Escaladé", code: ComplaintStatus.ESCALATED },
  { name: "En attente", code: ComplaintStatus.PENDING },
  { name: "Résolu positif", code: ComplaintStatus.RESOLVED_POSITIVE },
  { name: "Résolu négatif", code: ComplaintStatus.RESOLVED_NEGATIVE },
  { name: "Archivée", code: ComplaintStatus.ARCHIVED },
  { name: "Enregistrée", code: ComplaintStatus.SAVED },
  { name: "En cours de validation", code: ComplaintStatus.IN_PROGRESS_VALIDATION },
  { name: "En cours de traitement", code: ComplaintStatus.CURRENTLY_PROCESSED },
  { name: "En attente de réponse", code: ComplaintStatus.AWAITING_RESPONSE },
  { name: "Résolu", code: ComplaintStatus.RESOLVED },
];

export const incidentLocationOptions = [
  { name: "Autres", code: ComplaintIncidentLocation.OTHER },
  { name: "Centre de santé", code: ComplaintIncidentLocation.HEALTH_CENTER },
  { name: "Domicile", code: ComplaintIncidentLocation.HOME },
  { name: "École", code: ComplaintIncidentLocation.SCHOOL },
  {
    name: "Institution publique",
    code: ComplaintIncidentLocation.PUBLIC_INSTITUTION,
  },
  {
    name: "Internet / Réseaux sociaux",
    code: ComplaintIncidentLocation.INTERNET_SOCIAL_MEDIA,
  },
  { name: "Lieu de travail", code: ComplaintIncidentLocation.WORKPLACE },
  { name: "Rue", code: ComplaintIncidentLocation.STREET },
  {
    name: "Transport public",
    code: ComplaintIncidentLocation.PUBLIC_TRANSPORT,
  },
];

export const SituationTranslations: Record<
  ComplaintMatrimonialSituation,
  string
> = {
  [ComplaintMatrimonialSituation.MARIED]: "Marié(e)",
  [ComplaintMatrimonialSituation.SINGLE]: "Célibataire",
  [ComplaintMatrimonialSituation.DIVORCED]: "Divorcé(e)",
  [ComplaintMatrimonialSituation.WIDOWED]: "Veuf(ve)",
};

export interface AggressorDetails {
  id: number;
  firstName: string;
  lastName: string;
  gender: ComplaintGender;
  address: string;
  ageGroup: ComplaintAgeGroup;
  victimRelationShip: ComplaintRelationshipWithVictim;
  nationality: string;
  complaintId: number;
}

export interface ComplaintUsers {
  id: number;
  complaintId: number;
  user: {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    address: string;
    createdAt: Date | null;
    profil: any;
    fokontany: any;
    region: any;
  };
  createdAt: Date;
  profil: {
    id: string;
    name: string;
    description: string;
  };
  actionTaken: string;
  status: string;
  supportTypes: any[];
  oldStatus: string;
  newStatus: string;
  oldRef: string;
  newRef: string;
  fieldChanged: string;
}
export interface ComplaintById {
  id: number;
  description: string;
  object?: ObjectInternalAgent
  ref: string;
  createdAt: Date | string;
  incidentLocation: ComplaintIncidentLocation;
  careInstruction: ComplaintCareInstruction;
  incidentDate: Date | string;
  receivedDate: Date | string;
  status: ComplaintStatus;
  priority: complaintPriority;
  rsuRelated: boolean;
  sensivity: ComplaintPersonType;
  resolutionLevel: ComplaintResolutionLevel;
  complaintUsers: ComplaintUsers[];
  complaintSubNatures: ComplaintSubNatures[];
  user: {
    id: string;
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    address: string;
    createdAt: string;
    profil: {
      id: string;
      name: string;
      description: string;
      permissions: [
        {
          id: string;
          name: string;
          description: string;
        }
      ];
      accesses: [
        {
          id: string;
          name: string;
          description: string;
        }
      ];
    };
    fokontany: {
      id: number;
      name: string;
      code: string;
      municipality: {
        id: number;
        name: string;
        code: string;
      };
    };
    region: {
      id: number;
      name: string;
      code: string;
    };
  };
  report: {
    id: number;
    partnerId: number;
    periode: number;
    importDate: number;
    type: ComplaintReportType;
    status: ComplaintReportStatus;
  };
  fokontany: {
    id: number;
    name: string;
    code: string;
    municipality: {
      id: number;
      name: string;
      code: string;
      district: {
        id: number;
        name: string;
        code: number;
        region: {
          id: number;
          name: string;
          code: number;
        };
      };
    };
  };
  actionTaken: string;
  natures: NatureComplaintDTO[];
  subNatures: SubNatureComplaint[];
  aggressors: AggressorDetails[];
  complaintDetails: [
    {
      id: number;
      complaintId: number;
      requesterName: string;
      gender: ComplaintGender;
      ageGroup: ComplaintAgeGroup;
      disability: boolean;
      martialStatus: ComplaintMatrimonialSituation;
      cin: string;
      householdId: string;
      individualId: string;
      parentCohabitation: boolean;
      disabilityInfo: ComplaintDisabledInfo;
      contactNumber: string;
      contactAddress: string;
      fatherName: string;
      motherName: string;
      student: ComplaintJob;
      employee: ComplaintJob;
      firstName?: string;
      lastName?: string;
    }
  ];
  complaintInfo: {
    id: number;
    fullName: string;
    disabled: boolean;
    anonym: boolean;
    cinNumber: string;
    phoneNumber: string;
    householdId: string;
    individualId: string;
    address: string;
    relationshipWithVictim: ComplaintRelationshipWithVictim;
  };
}

export interface SupportTypeModel {
  id: number;
  description: string;
}
export interface RequiredStepFour{
  natureDysError: string
  institutionError: string
  programConcernedError: string
}
